// React Bits Spotlight Card (TS-TW), https://reactbits.dev/components/spotlight-card — adapted:
// the spotlight colour follows the theme and the glow fades in/out instead of snapping.

import { type ComponentProps, useRef } from 'react';
import { cn } from '@/lib/utils';

export function SpotlightCard({
  className,
  children,
  spotlightColor = 'color-mix(in oklch, var(--foreground) 9%, transparent)',
  ...props
}: ComponentProps<'div'> & { spotlightColor?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  return (
    <div
      ref={ref}
      onPointerMove={(e) => {
        const el = ref.current;
        if (!el) return;
        const rect = el.getBoundingClientRect();
        el.style.setProperty('--mouse-x', `${e.clientX - rect.left}px`);
        el.style.setProperty('--mouse-y', `${e.clientY - rect.top}px`);
      }}
      style={
        {
          '--spotlight-color': spotlightColor,
          '--mouse-x': '50%',
          '--mouse-y': '0%',
        } as React.CSSProperties
      }
      className={cn(
        'group/spotlight bg-surface relative isolate overflow-hidden rounded-2xl border',
        'before:pointer-events-none before:absolute before:inset-0 before:-z-10 before:opacity-0 before:transition-opacity before:duration-500',
        'before:bg-[radial-gradient(circle_at_var(--mouse-x)_var(--mouse-y),var(--spotlight-color),transparent_80%)]',
        'hover:before:opacity-100 focus-within:before:opacity-100',
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
}
